import type { I18nLocale } from "@/modules/i18n/types"

export const ADVICE_ALLOWED_LOCALES: I18nLocale[] = ["fr", "de", "en", "es", "nl", "da"]
